"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = require("immutable");

var _omit = _interopRequireDefault(require("transmute/omit"));

var _pick = _interopRequireDefault(require("transmute/pick"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _draftJs = require("draft-js");

var _RichTextEditorStateActions = require("../state/RichTextEditorStateActions");

var _RichTextEditor = _interopRequireDefault(require("./RichTextEditor"));

var omittedRteProps = ['editorState'];
var rteProps = (0, _omit.default)(omittedRteProps, (0, _immutable.Map)(_RichTextEditor.default.propTypes));
var pickRteProps = (0, _pick.default)(rteProps.keySeq());
var propTypes = (0, _extends2.default)({}, rteProps.toObject(), {
  value: _react.PropTypes.string
});
var defaultProps = {
  value: ''
}; // A facade for the RichTextEditor that allows clients to interact with the
// RichTextEditor vith HTML rather than draftjs editor state.  This is designed
// for simple use cases where initial HTML is supplied to the RTE and the client
// only needs to be notified on save or cancel.

var SimpleRichTextEditor =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(SimpleRichTextEditor, _PureComponent);

  function SimpleRichTextEditor(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SimpleRichTextEditor);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SimpleRichTextEditor).call(this, props));
    _this.rteContentMediator = (0, _RichTextEditorStateActions.getRichTextEditorContentMediator)(props.config);
    _this.state = _this.createState();

    _this.initRteProps(props);

    return _this;
  }

  (0, _createClass2.default)(SimpleRichTextEditor, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      this.initRteProps(newProps);

      if (newProps.value !== this.props.value) {
        this.setState({
          editorState: this.createEditorState(newProps.value)
        });
      }
    }
  }, {
    key: "initRteProps",
    value: function initRteProps(props) {
      this.rteProps = pickRteProps((0, _immutable.Seq)(props)).toObject();
    }
  }, {
    key: "createState",
    value: function createState() {
      var value = this.props.value;
      return {
        editorState: this.createEditorState(value)
      };
    }
  }, {
    key: "createEditorState",
    value: function createEditorState(html) {
      return _draftJs.EditorState.createWithContent(this.rteContentMediator.fromHtml(html));
    }
  }, {
    key: "render",
    value: function render() {
      var editorState = this.state.editorState;
      return _react.default.createElement(_RichTextEditor.default, (0, _extends2.default)({}, this.rteProps, {
        editorState: editorState
      }));
    }
  }]);
  return SimpleRichTextEditor;
}(_PureComponent2.default);

SimpleRichTextEditor.propTypes = propTypes;
SimpleRichTextEditor.defaultProps = defaultProps;
var _default = SimpleRichTextEditor;
exports.default = _default;
module.exports = exports.default;